<template>
  <form class="callcenter-form" @submit.prevent="submit">
    <div class="row">
      <div class="col-lg-6">
        <div class="card form-card">
          <div class="form-group">
            <label for="ticketNumber">{{ $t("messages.id-de-socio") }}</label>
            <div class="row">
              <div class="col-12">
                <input
                  v-model="input.latam_id"
                  type="text"
                  class="form-control"
                  required
                />
              </div>
              <div class="col-12 mt-4">
                <button class="btn btn-block btn-danger">
                  {{ $t("messages.solicitar") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  data() {
    return {
      input: {
        latam_id: ""
      }
    };
  },
  methods: {
    submit() {
      window.location.href = `callcenter/${this.input.latam_id}`;
    }
  }
};
</script>

